/* eslint camelcase: 0, no-unused-vars: 0, no-undef: 0 */

// This lets us have whatever entry point we want, but still resolve relative urls properly
// The silliness is due to webpack
// http://stackoverflow.com/questions/36675286/webpack-code-splitting-relative-url
// https://github.com/webpack/webpack/issues/2776
__webpack_public_path__ = `${window.location.protocol}//${window.location.host}/`

import "app/main"
